// Single source of truth for per-role screen access — LEAST PRIVILEGE defaults.
// Only DIRECTOR is leadership; every other role gets just the screens its job needs.
// The Director can override these from Settings → Role Permissions; the saved matrix is
// loaded by PermissionsContext and passed as the 3rd argument to canAccess / canAccessCrm.
export const ROUTE_ROLES = {
  "/": ["DIRECTOR"],
  "/leads": ["DIRECTOR", "CO_DIRECTOR", "HEAD_OFFICE", "CENTER_MANAGER"],
  "/app-leads": ["DIRECTOR", "CO_DIRECTOR", "CENTER_MANAGER"],
  "/students": ["DIRECTOR", "CO_DIRECTOR", "HEAD_OFFICE", "CENTER_MANAGER", "FACULTY", "FRANCHISE"],
  "/counselling": ["DIRECTOR", "CENTER_MANAGER"],
  "/tasks": ["DIRECTOR", "CO_DIRECTOR", "HEAD_OFFICE", "CENTER_MANAGER", "MARKETING", "FINANCE", "HR_ADMIN", "FACULTY", "FRANCHISE"],
  "/finance": ["DIRECTOR", "CO_DIRECTOR", "CENTER_MANAGER", "FINANCE", "FRANCHISE"],
  "/attendance": ["DIRECTOR", "CENTER_MANAGER", "FACULTY", "FRANCHISE"],
  "/approvals": ["DIRECTOR", "CO_DIRECTOR"],
  "/staff": ["DIRECTOR", "HR_ADMIN"],
  "/team": ["DIRECTOR", "CENTER_MANAGER", "HR_ADMIN"],
  "/settings": ["DIRECTOR", "HR_ADMIN"],
};

export const canAccess = (path, role, matrix = ROUTE_ROLES) => {
  const allow = matrix?.[path];
  return !allow || allow.length === 0 || allow.includes(role);
};

const D = "Director", CD = "Co-Director", FL = "Floor Lead", TC = "Telecaller", IC = "Inbound caller",
  CN = "Counsellor", BDM = "BDM", ACC = "Accounts", MK = "Marketing", CT = "Content", FM = "Faculty mentor";
// Admissions CRM screens (rcrm roles). Unlisted screens (home, token, chat, training) are open to any CRM user.
export const CRM_SCREEN_ROLES = {
  director: [D], warroom: [D], review: [D], trash: [D],
  meta: [D, CD], waconnect: [D, CD],
  tv: [D, CD, FL],
  payroll: [D, CD, ACC], reconcile: [D, ACC],
  machine: [D, CD], campaigns: [D, CD, MK], seminars: [D, CD, FL, MK, BDM, ACC],
  settings: [D, CD, FL, ACC], reports: [D, CD, FL, ACC],
  vidarbha: [D, CD, FL, MK, BDM], eventcmd: [D, CD, FL], outreach: [D, CD, FL, BDM, MK],
  leads: [D, CD, FL, BDM, ACC], pipeline: [D, CD, FL],
  queue: [D, CD, FL, TC, IC, CN], followups: [D, CD, FL, TC, IC, CN], myday: [D, CD, FL, TC, IC, CN],
  myleads: [CD, FL, TC, IC, CN, BDM], mobility: [D, CD, FL, ACC],
  reception: [D, CD, FL, CN, IC, ACC], token: [D, CD, FL, IC, ACC], seatreserve: [D, CD, FL, CN, TC, IC, MK, BDM, ACC],
  whatsapp: [D, CD, FL, CN, TC, IC, BDM, MK, ACC], bells: [D, CD, FL, BDM, MK, CT],
  rast: [D, CD, FL], events: [D, CD, FL, MK],
  schools: [D, CD, FL, BDM], cohorts: [D, CD, FL, MK],
  playbook: [D, CD, FL, BDM], earnings: [D, CD, FL, BDM, ACC],
  referrals: [D, CD, FL, MK], partners: [D, CD, FL, ACC], promise: [D, CD, FL, FM],
  intake: [D, CD, FL, TC, IC, CN, BDM, MK], incentives: [D, CD, FL, BDM, ACC, MK],
  calendar: [D, CD, FL, CN, TC, IC],
};
// Working roles whose whole day lives in My Leads / Today's Calls / Follow-ups.
export const CALLER_ROLES = [TC, IC, CN];
export const leadLink = (crmRole, leadId) => `${CALLER_ROLES.includes(crmRole) ? "/crm/myleads" : "/crm/leads"}?open=${encodeURIComponent(leadId)}`;

export const canAccessCrm = (screen, role, matrix = CRM_SCREEN_ROLES) => {
  const allow = matrix?.[screen];
  return !allow || allow.length === 0 || allow.includes(role);
};

// Roles with NO Admissions CRM access at all (bridge refuses them; CRM section hidden).
export const NO_CRM_ROLES = ["HR_ADMIN", "FRANCHISE"];
export const hasCrm = (role) => !NO_CRM_ROLES.includes(role);

// Role-appropriate landing screen when a user can't see the Command Center ("/").
export const ROLE_HOME = {
  DIRECTOR: "/crm", CO_DIRECTOR: "/crm", HEAD_OFFICE: "/crm", CENTER_MANAGER: "/crm",
  SENIOR_COUNSELLOR: "/crm/myleads", COUNSELLOR: "/crm/myleads", MARKETING: "/crm/campaigns",
  FINANCE: "/finance", FACULTY: "/attendance", HR_ADMIN: "/staff",
  DTP: "/crm/queue", FRANCHISE: "/students",
};
export const homeFor = (role) => ROLE_HOME[role] || "/tasks";
